const validateEduEmailAddress = (email: string): boolean => {
  // regex to check if email domain contains .edu, .ac, .edu.* , and .ac.*
  const regex = /@.*\.(edu|ac)(\..*)?$/;
  return regex.test(email);
};
export default validateEduEmailAddress;
